import { translateFn } from '../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';

export enum ColumnKeys {
  NAME = 'name',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: DefaultColumnKeys.REORDER,
      header: '',
      columnType: IColumnType.DISPLAY,
    },
    {
      key: DefaultColumnKeys.PRIORITY,
      header: translateFn('Priority'),
      columnType: IColumnType.DISPLAY,
    },
    {
      key: ColumnKeys.NAME,
      header: translateFn('Domains'),
      columnType: IColumnType.TEXT,
      editable: true,
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
